<template>
  <div>
    <div v-if="info" class="scan" ref="scan">
<!--      <div class="number">企业信用档案编号：{{ info.cert_code }}</div>-->
      <div class="number">编号：{{ info.cert_code }}</div>
      <div class="cardCont">
        <div class="cardThem">单位名称: {{ info.company_name }}</div>
        <div class="cardThem">统一社会信用代码：{{ info.social_code }}</div>
        <div class="cardThem">地 址：{{ info.register_address }}</div>
        <div class="cardThem">适用范围: {{ info.scopeuse }}</div>
<!--        <div class="cardThem">登记依据：{{ info.basis }}</div>-->
      </div>
      <div class="cardFoot">
        <div>
          <div class="date">产品名称及规格型号见附录</div>
          <img :src="'data:image/jpg;base64,' + info.cert_link" class="ma" />
        </div>
        <div class="cardDetail">
          <div class="date">有效期：二年</div>
          <div class="date">登记日期：{{ info.cert_time }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.scan {
  //width: 878px;
  //height: 620px;
  width: 1171px;
  height: 760px;
  //background-image: url("~@/assets/cardbgold.jpg");
  background-image: url("~@/assets/newbg.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .number {
    font-size: 14px;
    font-weight: 800;
    color: #0b307a;
    padding-top: 85px;
    text-align: right;
    padding-right: 132px;
  }
  .cardCont {
    padding-left: 277px;
    margin-top: 180px;
    .cardThem {
      width: 535px;
      font-size: 18px;
      font-weight: 800;
      line-height: 40px;
      color: rgba(51, 51, 51, 1);
      .register {
        margin-left: 75px;
      }
    }
  }
  .cardFoot {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding-left: 273px;
    padding-right: 268px;
    margin-top: 55px;
    .ma {
      width: 83px;
      height: 83px;
      margin-top: 10px;
    }
    .cardDetail {
    }
  }
  .date {
    font-size: 18px;
    font-weight: 800;
    line-height: 24px;
    color: rgba(51, 51, 51, 1);
  }
}
</style>
<script>
import Api from "@/plugins/axios.js";
import html2canvas from "html2canvas";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      uuid: null,
      agentType: null,
      type: null,
      info: null // 要显示的信息
    };
  },
  async mounted() {
    if (this.$route.query.uuid) {
      this.uuid = this.$route.query.uuid;
    }
    if (this.$route.query.agentType) {
      this.agentType = this.$route.query.agentType;
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    await this.init();
    const loadingInstance = Loading.service({ fullscreen: true });
    setTimeout(() => {
      loadingInstance.close();
      setTimeout(() => {
        if (this.type === "down") {
          this.photo();
        } else if (this.type === "print") {
          this.print();
        }
      }, 1000);
    }, 2000);
    // this.photo();
    // this.print();
  },
  methods: {
    async init() {
      this.info = await Api.suppercode(
        this.$store.state.token,
        this.uuid,
        this.agentType
      );
    },
    // 截图
    photo() {
      html2canvas(this.$refs.scan).then(canvas => {
        canvas.toBlob(function(blob) {
          const a = document.createElement("a");
          const url = URL.createObjectURL(blob, "image/png", 1);
          const filename = "证书";
          a.href = url;
          a.download = filename;
          a.click();
        });
      });
    },
    // 打印
    print() {
      window.print();
    }
  }
};
</script>
